import { log } from 'log';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { usePushSubscription } from 'js/hooks/socket';
import { useGameConfigurationSelector } from 'js/store/hooks/useGameConfigurationSelector';

import * as helpers from '../helpers';
import { useDynamicReducerDispatch } from '../store';
import { updateRecentlyPlayedCategory } from '../store/actions';

export const useRecentlyPlayedSubscription = () => {
    const dispatch = useDynamicReducerDispatch();
    const allGames = useGameConfigurationSelector(prop('games'));
    const { isInternalPlayer } = useUserSelector(prop('userDetails'));

    usePushSubscription(31133, () => (pushMessage) => {
        const { notificationPlayerTagChangeInfo = {} } = pushMessage?.data?.notification || {};
        const { tag, value } = notificationPlayerTagChangeInfo;

        if (tag === 'uam/hidden/playerRecentGames') {
            let recentlyPlayedGames: string[] = [];

            try {
                recentlyPlayedGames = JSON.parse(value) as string[];
            } catch (error) {
                log('error', '[Games Grid] unable to parse uam/hidden/playerRecentGames value', error);
            }

            const filteredGames = helpers.filterGamesByAvailability({
                gameCodes: recentlyPlayedGames, allGames, isInternalPlayer
            });

            dispatch(updateRecentlyPlayedCategory(filteredGames));
        }
    }, {}, [dispatch]);
};
